import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

export enum ListStyles {
  LIST = "list",
  GRID_SMALL = "grid_small",
  GRID_BIG = "grid_big",
}

@customElement("list-styles")
export default class ListStyleButtons extends LitElement {
  @property()
  accessor currentListStyle: string = ListStyles.LIST;

  createRenderRoot() {
    return this;
  }

  handleLayoutChange(listStyle: string) {
    console.log("handleChange:" + listStyle);

    //this.currentListStyle = listStyle;
    const event = new CustomEvent("layout-change", {
      detail: { currentListStyle: listStyle },
      bubbles: true, // Allows the event to bubble up to parent elements
      composed: true, // Allows the event to pass through shadow DOM boundaries
    });

    this.dispatchEvent(event);
  }

  render() {
    return html`
      <div
        class="sorting max-w-site-maxwidth mx-auto flex items-center justify-end gap-6 site-gutter w-full"
      >
        <button
          type="button"
          class="${this.currentListStyle == ListStyles.GRID_BIG
            ? "text-medium-blue-100"
            : "text-darker-blue-100"} "
          @click="${() => this.handleLayoutChange(ListStyles.GRID_BIG)}"
        >
          <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.356864"
              y="0.214286"
              width="12.2143"
              height="12.0714"
              rx="0.642857"
              fill="currentColor"
            />
            <rect
              x="0.356864"
              y="0.214286"
              width="12.2143"
              height="12.0714"
              rx="0.642857"
              stroke="currentColor"
              stroke-width="0.428571"
            />
            <rect
              x="13.9994"
              y="0.214286"
              width="12.2143"
              height="12.0714"
              rx="0.642857"
              fill="currentColor"
            />
            <rect
              x="13.9994"
              y="0.214286"
              width="12.2143"
              height="12.0714"
              rx="0.642857"
              stroke="currentColor"
              stroke-width="0.428571"
            />
            <rect
              x="0.356864"
              y="13.7143"
              width="11.7143"
              height="12.0714"
              rx="0.642857"
              fill="currentColor"
            />
            <rect
              x="0.356864"
              y="13.7143"
              width="11.7143"
              height="12.0714"
              rx="0.642857"
              stroke="currentColor"
              stroke-width="0.428571"
            />
            <rect
              x="13.2852"
              y="13.5"
              width="13.1429"
              height="12.5"
              rx="0.857143"
              fill="currentColor"
            />
          </svg>
        </button>
        <button
          type="button"
          class="${this.currentListStyle == ListStyles.GRID_SMALL
            ? "text-medium-blue-100"
            : "text-darker-blue-100"} "
          @click="${() => this.handleLayoutChange(ListStyles.GRID_SMALL)}"
        >
          <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.427734"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="9.52344"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="18.6191"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="0.427734"
              y="9"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="9.52344"
              y="9"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="18.6191"
              y="9"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="0.427734"
              y="18"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="9.52344"
              y="18"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
            <rect
              x="18.6191"
              y="18"
              width="8.09524"
              height="8"
              rx="0.857143"
              fill="currentColor"
            />
          </svg>
        </button>
        <button
          type="button"
          class="${this.currentListStyle == ListStyles.LIST
            ? "text-medium-blue-100"
            : "text-darker-blue-100"} "
          @click="${() => this.handleLayoutChange(ListStyles.LIST)}"
        >
          <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="26.2857"
              height="7.33333"
              transform="translate(0.714844)"
              fill="currentColor"
            />
            <rect
              x="0.929129"
              y="0.214286"
              width="25.8571"
              height="6.90476"
              rx="0.642857"
              stroke="currentColor"
              stroke-width="0.428571"
            />
            <rect
              width="26.2857"
              height="7.33333"
              transform="translate(0.714844 9.33203)"
              fill="currentColor"
            />
            <rect
              x="0.929129"
              y="9.54632"
              width="25.8571"
              height="6.90476"
              rx="0.642857"
              stroke="currentColor"
              stroke-width="0.428571"
            />
            <rect
              x="0.929129"
              y="18.8823"
              width="25.8571"
              height="6.90476"
              rx="0.642857"
              fill="currentColor"
            />
            <rect
              x="0.929129"
              y="18.8823"
              width="25.8571"
              height="6.90476"
              rx="0.642857"
              stroke="currentColor"
              stroke-width="0.428571"
            />
          </svg>
        </button>
      </div>
    `;
  }
}
